import styled, { keyframes } from 'styled-components'
import * as PopoverPrimitive from '@radix-ui/react-popover'

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`

export const PopoverContentFrame = styled(PopoverPrimitive.Content).withConfig({
  shouldForwardProp: (prop) => prop !== '$width',
})<{ $width: number }>`
  z-index: ${({ theme }) => theme.zIndex.popover};
  width: ${({ $width }) => $width}px;
  max-width: calc(100vw - 16px);
  padding: ${({ theme }) => theme.spacing.medium};
  background: ${({ theme }) => theme.colors.background.primary};
  color: ${({ theme }) => theme.colors.text.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  box-shadow: ${({ theme }) => theme.shadows.lg};
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};

  &[data-state='open'] {
    animation: ${fadeIn} 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  }
`
